(function () {
  'use strict';

  /* ── Shopify data bridge ──────────────────────────────────────── */
  const shopify = window.__JB_CUSTOMIZER__ || {};

  /* ── Hardcoded fallback data ──────────────────────────────────── */
  const FALLBACK_FABRIC_COLORS = [
    { id: 'white',      color: '#FDFDFB', name: 'White' },
    { id: 'ivory',      color: '#F5F5F0', name: 'Ivory' },
    { id: 'champagne',  color: '#F0E6D2', name: 'Champagne' },
    { id: 'light-blue', color: '#D4E4F0', name: 'Light Blue' },
    { id: 'sage',       color: '#B5C4A1', name: 'Sage' },
    { id: 'blush',      color: '#F4D6CC', name: 'Blush' },
    { id: 'charcoal',   color: '#4A4A4A', name: 'Charcoal' },
    { id: 'navy',       color: '#1E2B4D', name: 'Navy' },
    { id: 'burgundy',   color: '#6B2E35', name: 'Burgundy' },
    { id: 'forest',     color: '#3E4D3A', name: 'Forest Green' },
  ];

  const FALLBACK_EMBROIDERY_COLORS = [
    { id: 'white-emb',    color: '#FDFDFB', name: 'White' },
    { id: 'ivory-emb',    color: '#F5F5F0', name: 'Ivory' },
    { id: 'black-emb',    color: '#353535', name: 'Black' },
    { id: 'charcoal-emb', color: '#4A4A4A', name: 'Charcoal' },
    { id: 'navy-emb',     color: '#1E2B4D', name: 'Navy' },
    { id: 'sage-emb',     color: '#8A9A7B', name: 'Sage' },
    { id: 'blush-emb',    color: '#F4D6CC', name: 'Blush' },
    { id: 'burgundy-emb', color: '#6B2E35', name: 'Burgundy' },
    { id: 'gold-emb',     color: '#D4A745', name: 'Gold' },
    { id: 'silver-emb',   color: '#B8B8B8', name: 'Silver' },
  ];

  const FALLBACK_COLOR_OPTIONS = [
    { id: 'white-black',    styleObj: { background: 'linear-gradient(to top right, #FDFDFB 0%, #FDFDFB 49.9%, #353535 50%, #353535 100%)', border: '1px solid #D4D4D4' }, ariaLabel: 'White Fabric / Black Embroidery' },
    { id: 'white-ivory',    styleObj: { backgroundColor: '#FDFDFB', border: '1px solid #D4D4D4' },                                                                         ariaLabel: 'White Fabric / Ivory' },
    { id: 'green-diagonal', styleObj: { background: 'linear-gradient(to top right, #F5F5F0 0%, #F5F5F0 49.9%, #3E4D3A 50%, #3E4D3A 100%)', border: '1px solid #D4D4D4' }, ariaLabel: 'Green diagonal split' },
    { id: 'blue-diagonal',  styleObj: { background: 'linear-gradient(to top right, #F5F5F0 0%, #F5F5F0 49.9%, #1E2B4D 50%, #1E2B4D 100%)', border: '1px solid #D4D4D4' }, ariaLabel: 'Blue diagonal split' },
    { id: 'navy-white',     styleObj: { background: 'linear-gradient(to top right, #1E2B4D 0%, #1E2B4D 49.9%, #FFFFFF 50%, #FFFFFF 100%)', border: '1px solid #D4D4D4' },  ariaLabel: 'Navy / White' },
    { id: 'blush-cream',    styleObj: { background: 'linear-gradient(to top right, #F4D6CC 0%, #F4D6CC 49.9%, #F5F5F0 50%, #F5F5F0 100%)', border: '1px solid #D4D4D4' }, ariaLabel: 'Blush / Cream' },
    { id: 'charcoal-grey',  styleObj: { backgroundColor: '#4A4A4A', border: '1px solid #D4D4D4' },                                                                         ariaLabel: 'Charcoal Grey' },
    { id: 'sage-green',     styleObj: { backgroundColor: '#8A9A7B', border: '1px solid #D4D4D4' },                                                                         ariaLabel: 'Sage Green' },
    { id: 'dusty-rose',     styleObj: { backgroundColor: '#D4A5A5', border: '1px solid #D4D4D4' },                                                                         ariaLabel: 'Dusty Rose' },
    { id: 'terracotta',     styleObj: { backgroundColor: '#C67B5C', border: '1px solid #D4D4D4' },                                                                         ariaLabel: 'Terracotta' },
    { id: 'burgundy-cream', styleObj: { background: 'linear-gradient(to top right, #6B2E35 0%, #6B2E35 49.9%, #F5F5F0 50%, #F5F5F0 100%)', border: '1px solid #D4D4D4' }, ariaLabel: 'Burgundy / Cream' },
    { id: 'teal-white',     styleObj: { background: 'linear-gradient(to top right, #2C5F6F 0%, #2C5F6F 49.9%, #FFFFFF 50%, #FFFFFF 100%)', border: '1px solid #D4D4D4' },  ariaLabel: 'Teal / White' },
    { id: 'mustard',        styleObj: { backgroundColor: '#D4A745', border: '1px solid #D4D4D4' },                                                                         ariaLabel: 'Mustard' },
    { id: 'lavender',       styleObj: { backgroundColor: '#B5A8C7', border: '1px solid #D4D4D4' },                                                                         ariaLabel: 'Lavender' },
  ];

  const FALLBACK_MONOGRAM_COLORS = [
    { id: 'ivory',   name: 'Ivory',   color: '#F5F5DC' },
    { id: 'white',   name: 'White',   color: '#FFFFFF' },
    { id: 'sage',    name: 'Sage',    color: '#9DC183' },
    { id: 'seafoam', name: 'Seafoam', color: '#93E9BE' },
    { id: 'ecru',    name: 'Ecru',    color: '#C2B280' },
    { id: 'navy',    name: 'Navy',    color: '#000080' },
    { id: 'black',   name: 'Black',   color: '#000000' },
    { id: 'gold',    name: 'Gold',    color: '#FFD700' },
  ];

  const FALLBACK_RECOMMENDED = [
    { id: 'C14', name: 'C14', placeholder: '', max: 3, colorQty: 2, image: 'https://cdn.shopify.com/s/files/1/0261/5715/4350/files/C14.png', hoverImage: 'https://cdn.shopify.com/s/files/1/0261/5715/4350/files/C14_em.png' },
    { id: 'A56', name: 'A56', placeholder: '', max: 3, colorQty: 1, image: 'https://cdn.shopify.com/s/files/1/0261/5715/4350/files/A56.png', hoverImage: 'https://cdn.shopify.com/s/files/1/0261/5715/4350/files/A56_em.png' },
    { id: 'A61', name: 'A61', placeholder: '', max: 1, colorQty: 2, image: 'https://cdn.shopify.com/s/files/1/0261/5715/4350/files/A61.png', hoverImage: 'https://cdn.shopify.com/s/files/1/0261/5715/4350/files/A61_em.png' },
    { id: 'A11', name: 'A11', placeholder: '', max: 3, colorQty: 1, image: 'https://cdn.shopify.com/s/files/1/0261/5715/4350/files/A11.png', hoverImage: 'https://cdn.shopify.com/s/files/1/0261/5715/4350/files/A11_em.png' },
  ];

  const FALLBACK_CLASSIC = [
    { id: 'C01', name: 'C01', placeholder: 'S'   }, { id: 'C02', name: 'C02', placeholder: 'GA'  },
    { id: 'C03', name: 'C03', placeholder: 'JKL' }, { id: 'C04', name: 'C04', placeholder: 'L'   },
    { id: 'C05', name: 'C05', placeholder: 'OG'  }, { id: 'C06', name: 'C06', placeholder: 'NG'  },
    { id: 'C07', name: 'C07', placeholder: 'MMS' }, { id: 'C08', name: 'C08', placeholder: 'JB'  },
    { id: 'C09', name: 'C09', placeholder: 'A'   }, { id: 'C10', name: 'C10', placeholder: 'O'   },
    { id: 'C11', name: 'C11', placeholder: 'A'   }, { id: 'C12', name: 'C12', placeholder: 'M'   },
  ];

  const FALLBACK_CONTEMPORARY = [
    { id: 'M01', name: 'M01', placeholder: 'GG' }, { id: 'M02', name: 'M02', placeholder: 'M'  },
    { id: 'M03', name: 'M03', placeholder: 'ET' }, { id: 'M04', name: 'M04', placeholder: 'ER' },
    { id: 'M05', name: 'M05', placeholder: 'RF' }, { id: 'M06', name: 'M06', placeholder: 'CL' },
    { id: 'M07', name: 'M07', placeholder: 'SD' }, { id: 'M08', name: 'M08', placeholder: 'JP' },
    { id: 'M09', name: 'M09', placeholder: 'HH' }, { id: 'M10', name: 'M10', placeholder: '*'  },
    { id: 'M11', name: 'M11', placeholder: 'A'  }, { id: 'M12', name: 'M12', placeholder: 'K'  },
  ];

  const FALLBACK_CHILDREN = [
    { id: 'K01', name: "K01 Children's", placeholder: 'ET'  }, { id: 'K02', name: "K02 Children's", placeholder: 'M'   },
    { id: 'K03', name: "K03 Children's", placeholder: 'SS'  }, { id: 'K04', name: "K04 Children's", placeholder: 'N'   },
    { id: 'K05', name: "K05 Children's", placeholder: 'ESB' }, { id: 'K06', name: "K06 Children's", placeholder: 'S'   },
    { id: 'K07', name: "K07 Children's", placeholder: 'JP'  }, { id: 'K08', name: "K08 Children's", placeholder: 'PL'  },
  ];

  const FALLBACK_POSITIONS = [
    { location: 'Center',              image: 'https://cdn.shopify.com/s/files/1/0660/2283/4419/files/Sham_Monogram_-_Center.avif' },
    { location: 'Top Center',          image: 'https://cdn.shopify.com/s/files/1/0660/2283/4419/files/Sham_Monogram_-_Top_Center.avif' },
    { location: 'Angled Right Corner', image: 'https://cdn.shopify.com/s/files/1/0660/2283/4419/files/Shams_Angled_Right_Corner.jpg?v=1693581469' },
    { location: 'Angled Left Corner',  image: 'https://cdn.shopify.com/s/files/1/0660/2283/4419/files/Shams_Angled_Left_Corner.jpg' },
  ];

  /* ── Data transformation helpers ─────────────────────────────── */

  function buildFabricColorsFromShopify(raw) {
    if (!Array.isArray(raw) || !raw.length) return null;
    return raw.map((c, i) => ({
      id:    'f' + i,
      color: c.hex || '#FDFDFB',
      name:  c.label || ('Color ' + (i + 1)),
    }));
  }

  function buildEmbroideryColorsFromShopify(raw, prefix) {
    if (!Array.isArray(raw) || !raw.length) return null;
    const p = prefix || 'e';
    return raw.map((c, i) => ({
      id:    p + i,
      color: c.hex || c.hex2 || '#353535',
      name:  c.label || ('Color ' + (i + 1)),
    }));
  }

  function buildMonogramColors(raw) {
    if (!Array.isArray(raw) || !raw.length) return null;
    return raw.map((c, i) => ({
      id:    'mc' + i,
      color: c.hex || '#CCCCCC',
      name:  c.label || ('Color ' + (i + 1)),
    }));
  }

  function buildColorOptionsFromShopify(raw) {
    if (!Array.isArray(raw) || !raw.length) return null;
    return raw.map((c, i) => {
      let styleObj;
      if (c.image_url) {
        styleObj = { backgroundImage: 'url(' + c.image_url + ')', backgroundSize: 'cover', backgroundPosition: 'center', border: '1px solid #D4D4D4' };
      } else if (c.hex) {
        styleObj = { backgroundColor: c.hex, border: '1px solid #D4D4D4' };
      } else {
        styleObj = { backgroundColor: '#D4D4D4', border: '1px solid #D4D4D4' };
      }
      return {
        id: 'c' + i,
        styleObj,
        ariaLabel:   c.label || ('Color ' + (i + 1)),
        monoHex1:    c.monogram_suggestion_hex1 || null,
        monoHex2:    c.monogram_suggestion_hex2 || null,
      };
    });
  }

  function buildHeroImages(raw) {
    if (!raw) return null;
    const arr = Array.isArray(raw) ? raw : (typeof raw === 'object' && raw.images ? raw.images : [raw]);
    const mapped = arr
      .filter(img => !img.media_type || img.media_type === 'image')
      .map(img => ({
        src:     img.src || img.url || img.image ||
                 (img.preview_image && img.preview_image.src) ||
                 (typeof img === 'string' ? img : ''),
        src2x:   img.src2x || '',
        caption: img.caption || img.alt || img.title || '',
        ratio:   img.ratio || 1,
        width:   img.width  || 0,
        height:  img.height || 0,
      }))
      .filter(img => img.src);
    return mapped.length ? mapped : null;
  }

  /* Accepts flat array [{id, name, img1, img2, max, type, color1, color2, c_QTY}, ...]
     Returns { classic: [...], contemporary: [...], children: [...] }
     Also accepts legacy pre-grouped object for backwards compatibility. */
  function buildMonogramStyles(data) {
    if (!data) return null;
    // Flat array format (new)
    if (Array.isArray(data)) {
      if (!data.length) return null;
      const byType = {};
      data.forEach(s => {
        const t = s.type || 'classic';
        if (!byType[t]) byType[t] = [];
        byType[t].push({
          id:        s.id,
          name:      s.name || s.id,
          image:     s.img1 || '',
          hoverImage: s.img2 || s.img1 || '',
          placeholder: '',
          max:       s.max  || 3,
          colorQty:  parseInt(s.c_QTY, 10) || 1,
        });
      });
      return byType;
    }
    // Legacy pre-grouped object format — extract one key
    if (typeof data === 'string') return null;
    return data;
  }

  /* Legacy single-key extractor for callers that need one tab's array */
  function getMonogramStyleTab(styles, key) {
    if (!styles) return null;
    const arr = styles[key] || styles[key + 's'];
    return Array.isArray(arr) && arr.length ? arr : null;
  }

  function buildMonogramPositions(raw) {
    if (!Array.isArray(raw) || !raw.length) return null;
    return raw.map(p => ({
      location:        p.location || p.name  || p.label || '',
      image:           p.image_url || p.image || p.src  || p.img || '',
      product_type_id: p.product_type_id != null ? parseInt(p.product_type_id, 10) : null,
    }));
  }

  function formatPrice(cents, currency) {
    const syms = { EUR: '€', USD: '$', GBP: '£', CAD: 'CA$', AUD: 'A$', CHF: 'CHF ' };
    return (syms[currency] || (currency + ' ')) + (cents / 100).toFixed(2);
  }

  /* Numeric type from customizer-product-data metafield:
     1=pillowcase, 2=top_sheet, 3=fitted_sheet (sleeping ≤3)
     4=sham, 5=duvet_cover, 6=coverlet (decorative ≥4) */
  const TYPE_KEY_MAP = { 1: 'pillowcase', 2: 'topSheet', 3: 'fittedSheet', 4: 'sham', 5: 'duvetCover', 6: 'coverlet' };

  /* Maps Shopify backend fabric option values → frontend display names.
     "Pure Bliss" (generic) expands into both Cotton and Linen variants. */
  const FABRIC_DISPLAY_MAP = {
    'percale':           'Cotton Percale',
    'cotton percale':    'Cotton Percale',
    'linen':             'Fine Linen',
    'fine linen':        'Fine Linen',
    'pure bliss cotton': 'Pure Bliss Cotton',
    'pure bliss linen':  'Pure Bliss Linen',
  };

  function normalizeFabricTypes(rawValues) {
    const result = [];
    const seen   = new Set();
    for (const v of rawValues) {
      const key = v.trim().toLowerCase();
      if (key === 'pure bliss') {
        for (const pb of ['Pure Bliss Cotton', 'Pure Bliss Linen']) {
          if (!seen.has(pb)) { seen.add(pb); result.push(pb); }
        }
      } else {
        const display = FABRIC_DISPLAY_MAP[key] || v;
        if (!seen.has(display)) { seen.add(display); result.push(display); }
      }
    }
    return result;
  }

  function getVariantOptionVal(v, idx) {
    if (idx === 0) return v.o1 || '';
    if (idx === 1) return v.o2 || '';
    if (idx === 2) return v.o3 || '';
    return '';
  }

  /* Fitted Sheet (type 3, see TYPE_KEY_MAP) is restricted to White / Ecru only per
     client request, hardcoded by type rather than a tag since every fitted sheet
     bundle item across all pattern bundles carries this type. Ecru chip hex
     (#fffeea) is client-specified; White keeps the standard palette white. */
  const WHITE_ECRU_ONLY_TYPES = [3];
  const WHITE_ECRU_COLOR_OPTIONS = [
    { id: 'white', styleObj: { backgroundColor: '#FDFDFB', border: '1px solid #D4D4D4' }, ariaLabel: 'White' },
    { id: 'ecru',  styleObj: { backgroundColor: '#fffeea', border: '1px solid #D4D4D4' }, ariaLabel: 'Ecru' },
  ];

  function buildProducts(rawProducts, sleepingOpts, decorOpts, currency) {
    if (!Array.isArray(rawProducts) || !rawProducts.length) return null;
    return rawProducts.map(p => {
      const typeNum          = parseInt(p.type, 10);
      /* sleeping: types 1-3; decorative: types 4-6; unknown/unset: default to sleeping */
      const isSleeping       = isNaN(typeNum) || typeNum < 1 || typeNum > 6 ? true : typeNum <= 3;
      const hasMonogram      = !!p.monogramVariantId || (Array.isArray(allMonogramPositions) && allMonogramPositions.some(pos => pos.product_type_id === typeNum));

      const options  = Array.isArray(p.options)  ? p.options  : [];
      const variants = Array.isArray(p.variants) ? p.variants : [];

      /* Find which option index holds fabric / size */
      const fabricOptIdx = options.findIndex(o => /base.?fabric|fabric/i.test(o));
      const sizeOptIdx   = options.findIndex(o => /size/i.test(o));

      /* Extract unique sizes in variant order */
      const sizes = [];
      if (sizeOptIdx >= 0) {
        const seen = new Set();
        for (const v of variants) {
          const sz = getVariantOptionVal(v, sizeOptIdx);
          if (sz && !seen.has(sz)) { seen.add(sz); sizes.push(sz); }
        }
      }

      /* Extract & normalise fabric types */
      let fabricTypes = ['Cotton Percale', 'Fine Linen'];
      if (fabricOptIdx >= 0) {
        const rawFabrics = [];
        const seen = new Set();
        for (const v of variants) {
          const f = getVariantOptionVal(v, fabricOptIdx);
          if (f && !seen.has(f)) { seen.add(f); rawFabrics.push(f); }
        }
        if (rawFabrics.length) fabricTypes = normalizeFabricTypes(rawFabrics);
      }

      const hasPureBliss = fabricTypes.some(f => f.startsWith('Pure Bliss'));
      const colorOpts    = WHITE_ECRU_ONLY_TYPES.includes(typeNum)
        ? WHITE_ECRU_COLOR_OPTIONS
        : isSleeping
          ? (sleepingOpts || FALLBACK_COLOR_OPTIONS)
          : (decorOpts    || FALLBACK_COLOR_OPTIONS);
      const img = (p.image || '');

      return makeProduct({
        key:               TYPE_KEY_MAP[typeNum] || String(typeNum),
        typeNum,
        title:             p.title,
        image:             img.startsWith('//') ? 'https:' + img : img,
        unitPriceCents:    p.price,
        price:             formatPrice(p.price, currency),
        shopifyId:         p.id,
        variantId:         p.variantId,
        monogramVariantId: p.monogramVariantId || null,
        tags:              Array.isArray(p.tags) ? p.tags : [],
        hasPureBliss,
        hasMonogram,
        fabricTypes,
        sizes,
        size:              sizes[0] || '',
        fabricType:        fabricTypes[0] || 'Cotton Percale',
        colorOptions:      colorOpts,
        variantData:       variants,
        fabricOptIdx,
        sizeOptIdx,
      });
    });
  }

  /* ── makeProduct helper ───────────────────────────────────────── */
  function makeProduct(cfg) {
    const p = Object.assign({
      color:             'white-black',
      colorChosen:       false,
      customColorInfo:   null,
      variantAvailable:  true,
      quantity:          1,
      monogram:          false,
      monogramSelection: null,
      message:           '',
      showAllColors:     false,
      pureBlissExpanded: false,
      colorOptions:      FALLBACK_COLOR_OPTIONS,
      initials:          '',
      initial:           '',
      customRequest:     '',
      bdayName:          '',
      bdayDay:           '',
      bdayMonth:         '',
      bdayYear:          '',
    }, cfg);
    // Pre-select first recommended color on load
    if (p.colorOptions && p.colorOptions.length && !cfg.color) {
      p.color = p.colorOptions[0].id;
      p.colorChosen = true;
    }
    return p;
  }

  /* ── Build runtime data from Shopify or fallbacks ────────────── */
  const fabricColors       = buildFabricColorsFromShopify(shopify.fabricColors)                      || FALLBACK_FABRIC_COLORS;
  const embroideryColors   = buildEmbroideryColorsFromShopify(shopify.embroideryColors,  'e')        || FALLBACK_EMBROIDERY_COLORS;
  const embroidery2Colors  = buildEmbroideryColorsFromShopify(shopify.embroidery2Colors, 'e2')       || [];
  const appliqueColors     = buildEmbroideryColorsFromShopify(shopify.appliqueColors,    'a')        || [];
  const applique2Colors    = buildEmbroideryColorsFromShopify(shopify.applique2Colors,   'a2')       || [];
  const sleepingColorOpts  = buildColorOptionsFromShopify(shopify.suggestedMainColors)  || FALLBACK_COLOR_OPTIONS;
  /* decorative falls back to sleeping opts if no decorative collection is configured */
  const decorColorOpts     = buildColorOptionsFromShopify(shopify.suggestedDecorColors) || sleepingColorOpts;

  const customRequestDefault   = shopify.customRequestDefault   || "Can't find exactly what you're looking for? At Julia B. Casa, we delight in tailoring linens to your wishes — simply let us know what you need.";
  const customRequestMessages  = shopify.customRequestMessages  || {};

  const embroidery_exists  = !!shopify.embroidery_exists;
  const embroidery2_exists = !!shopify.embroidery2_exists;
  const applique_exists    = !!shopify.applique_exists;
  const applique2_exists   = !!shopify.applique2_exists;
  const embroideryLabel    = shopify.embroideryLabel   || 'Embroidery';
  const embroidery2Label   = shopify.embroidery2Label  || 'Secondary Embroidery';
  const _accentApplique = s => s.replace(/Applique\b/g, 'Appliqué').replace(/applique\b/g, 'appliqué');
  const appliqueLabel      = _accentApplique(shopify.appliqueLabel  || 'Appliqué');
  const applique2Label     = _accentApplique(shopify.applique2Label || 'Second Appliqué');
  const heroImgs          = buildHeroImages(shopify.heroImages);
  const bundleImgs        = buildHeroImages(shopify.bundleImages);
  const monoData          = shopify.monogramData;
  const monoStylesAll     = buildMonogramStyles(Array.isArray(monoData) ? monoData : null);
  const classicStyles     = (monoStylesAll && monoStylesAll.classic)       || getMonogramStyleTab(monoData, 'classic')       || FALLBACK_CLASSIC;
  const contemporaryStyles = (monoStylesAll && monoStylesAll.contemporary) || getMonogramStyleTab(monoData, 'contemporary')  || FALLBACK_CONTEMPORARY;
  const childrenStyles    = (monoStylesAll && (monoStylesAll.children || monoStylesAll.childrens))
                            || getMonogramStyleTab(monoData, 'childrens') || getMonogramStyleTab(monoData, 'children')       || FALLBACK_CHILDREN;
  const allMonogramPositions = buildMonogramPositions(shopify.monogramPositions) || FALLBACK_POSITIONS;
  const currency          = shopify.currency || 'EUR';

  /* Array.isArray (not just truthiness) matters here: an empty array means Liquid genuinely
     tried to load this bundle's products and found none (e.g. the mb-<handle> collection isn't
     published to the Online Store channel, or no products carry customizer-product-data) — that
     should show an honest empty state, never the FALLBACK_PRODUCTS demo photos. Those demo
     photos are only appropriate when shopify.products is missing entirely (local/no-bridge dev). */
  const hasShopifyProductsData = Array.isArray(shopify.products);
  const shopifyProducts = hasShopifyProductsData
    ? buildProducts(shopify.products, sleepingColorOpts, decorColorOpts, currency)
    : null;

  /* ── Fallback products (local dev / no Shopify data) ─────────── */
  const FALLBACK_PRODUCTS = [
    makeProduct({
      key: 'fittedSheet', typeNum: 3, title: 'Fitted Sheet',
      image: 'https://matouk-website.imgix.net/spree/products/219/large/Lowell_flat_Black_secondary.png',
      price: '€189.95', hasPureBliss: true, hasMonogram: false, hasCustomMessage: false,
      fabricTypes: ['Cotton Percale', 'Fine Linen', 'Pure Bliss Cotton', 'Pure Bliss Linen'],
      sizes: ['Twin  38" x 75"', 'Full  54" x 75"', 'Queen  60" x 80"', 'King  76" x 80"', 'Cal King  72" x 84"'],
      fabricType: 'Cotton Percale', size: 'Twin  38" x 75"',
      colorOptions: sleepingColorOpts,
    }),
    makeProduct({
      key: 'topSheet', typeNum: 2, title: 'Top Sheet',
      image: 'https://matouk-website.imgix.net/spree/products/219/large/Lowell_flat_Black_secondary.png',
      price: '€179.95', hasPureBliss: true, hasMonogram: true, hasCustomMessage: false,
      fabricTypes: ['Cotton Percale', 'Fine Linen', 'Pure Bliss Cotton', 'Pure Bliss Linen'],
      sizes: ['Twin 72" x 104"', 'Full 81" x 96"', 'Queen 94" x 112"', 'King 112" x 112"'],
      fabricType: 'Cotton Percale', size: 'Twin 72" x 104"',
      colorOptions: sleepingColorOpts,
    }),
    makeProduct({
      key: 'pillowcase', title: 'Pillow Case',
      image: 'https://matouk-website.imgix.net/spree/products/12628/large/Lowell_case_Black_primary.png',
      price: '€149.95', hasPureBliss: true, hasMonogram: true, hasCustomMessage: false, typeNum: 1,
      fabricTypes: ['Cotton Percale', 'Fine Linen', 'Pure Bliss Cotton', 'Pure Bliss Linen'],
      sizes: ['Standard 20″ x 26″', 'Queen 20″ x 30″', 'King 20″ x 36″'],
      fabricType: 'Cotton Percale', size: 'Standard 20″ x 26″',
      colorOptions: sleepingColorOpts,
    }),
    makeProduct({
      key: 'sham', typeNum: 4, title: 'Sham',
      image: 'https://matouk-website.imgix.net/spree/products/244/large/Lowell_sham_Black_primary2.png',
      price: '€258.95', hasPureBliss: false, hasMonogram: true, hasCustomMessage: true,
      fabricTypes: ['Cotton Percale', 'Fine Linen'],
      sizes: ['Boudoir 12″ x 16″', 'Standard 20″ x 26″', 'Euro 26″ x 26″'],
      fabricType: 'Cotton Percale', size: 'Boudoir 12″ x 16″',
      colorOptions: decorColorOpts,
    }),
    makeProduct({
      key: 'duvetCover', typeNum: 5, title: 'Duvet Cover',
      image: 'https://matouk-website.imgix.net/spree/products/2180/large/Lowell_Duvet_black_secondary.png',
      price: '€429.95', hasPureBliss: true, hasMonogram: true, hasCustomMessage: false,
      fabricTypes: ['Cotton Percale', 'Fine Linen', 'Pure Bliss Cotton', 'Pure Bliss Linen'],
      sizes: ['Twin 68" x 86"', 'Full 78" x 86"', 'Queen 88" x 90"', 'King 104" x 90"'],
      fabricType: 'Cotton Percale', size: 'Twin 68" x 86"',
      colorOptions: decorColorOpts,
    }),
    makeProduct({
      key: 'coverlet', typeNum: 6, title: 'Coverlet',
      image: 'https://juliab.com/cdn/shop/files/Letto_Calais_600x600.jpg',
      price: '€389.95', hasPureBliss: false, hasMonogram: true, hasCustomMessage: false,
      fabricTypes: ['Cotton Percale', 'Fine Linen'],
      sizes: ['Twin 68" x 90"', 'Full 84" x 90"', 'Queen 90" x 95"', 'King 106" x 95"'],
      fabricType: 'Cotton Percale', size: 'Twin 68" x 90"',
      colorOptions: decorColorOpts,
    }),
  ];

  /* ── Vue 3 App ────────────────────────────────────────────────── */
  const app = Vue.createApp({
    delimiters: ['${', '}'],

    data() {
      return {
        heroSlide:   0,
        bundleSlide: 0,
        aboutSlide:  0,
        showSizeChart: false,
        isFirstSelection: true,

        heroImages: heroImgs || [
          { src: '/hero-image.jpg',     caption: shopify.productTitle || 'Julia B. Casa Collection' },
          { src: '/CalaisCloseup.webp', caption: 'Collection detail' },
        ],
        bundleImages: bundleImgs || heroImgs || [
          { src: '/hero-image.jpg',     caption: shopify.productTitle || 'Julia B. Casa Collection' },
          { src: '/CalaisCloseup.webp', caption: 'Collection detail' },
        ],

        fabricColors,
        embroideryColors,
        embroidery2Colors,
        appliqueColors,
        applique2Colors,
        embroidery_exists,
        embroidery2_exists,
        applique_exists,
        applique2_exists,
        customRequestDefault,
        customRequestMessages,
        embroideryLabel,
        embroidery2Label,
        appliqueLabel,
        applique2Label,
        monogramColors: buildMonogramColors(shopify.monogramColors) || FALLBACK_MONOGRAM_COLORS,
        recommendedStyles: (monoStylesAll && monoStylesAll.recommended) || getMonogramStyleTab(monoData, 'recommended') || FALLBACK_RECOMMENDED,
        classicStyles,
        contemporaryStyles,
        childrenStyles,
        monogramPositionImages: allMonogramPositions,

        products: shopifyProducts || (hasShopifyProductsData ? [] : FALLBACK_PRODUCTS),

        monogramPriceCents: shopify.monogramPriceCents || 0,
        monogramVariants:   shopify.monogramVariants || {},
        cartLoading: false,
        cartDrawer: { isOpen: false, loading: false, items: [], itemCount: 0, total: '' },

        svgMain:       null,
        svgDecorative: null,

        colorModal: {
          isOpen: false, productIdx: null,
          selectedFabric:      'f0',
          selectedEmbroidery:  'e0',
          selectedEmbroidery2: 'e20',
          selectedApplique:    'a0',
          selectedApplique2:   'a20',
          showAllFabric:       false,
          showAllEmbroidery:   false,
          showAllEmbroidery2:  false,
          showAllApplique:     false,
          showAllApplique2:    false,
        },

        monogramModal: {
          isOpen: false, productIdx: null, currentStep: 1,
          showAllStyles: false, activeTab: 'classic', activeLetterCount: 1, showCustomColors: false,
          hoveredStyleId: null, showAllLetterColors: false, showAllDetailColors: false,
          colorsConfirmed: false,
          selection: { styleId: null, styleName: '', styleImage: '', styleHoverImage: '', stylePlaceholder: '', letters: '', sleepingLetterColor: 'ecru', sleepingDetailColor: 'ecru', location: '' },
        },
      };
    },

    computed: {
      visibleFabricColors()      { return this.colorModal.showAllFabric       ? this.fabricColors      : this.fabricColors.slice(0, 6); },
      visibleEmbroideryColors()  { return this.colorModal.showAllEmbroidery   ? this.embroideryColors  : this.embroideryColors.slice(0, 6); },
      visibleEmbroidery2Colors() { return this.colorModal.showAllEmbroidery2  ? this.embroidery2Colors : this.embroidery2Colors.slice(0, 6); },
      visibleAppliqueColors()    { return this.colorModal.showAllApplique      ? this.appliqueColors    : this.appliqueColors.slice(0, 6); },
      visibleApplique2Colors()   { return this.colorModal.showAllApplique2     ? this.applique2Colors   : this.applique2Colors.slice(0, 6); },
      selectedFabricHex()        { const c = this.fabricColors.find(c => c.id === this.colorModal.selectedFabric);       return c ? c.color : '#FDFDFB'; },
      selectedEmbroideryHex()    { const c = this.embroideryColors.find(c => c.id === this.colorModal.selectedEmbroidery);  return c ? c.color : '#353535'; },
      selectedEmbroidery2Hex()   { const c = this.embroidery2Colors.find(c => c.id === this.colorModal.selectedEmbroidery2); return c ? c.color : '#353535'; },
      selectedAppliqueHex()      { const c = this.appliqueColors.find(c => c.id === this.colorModal.selectedApplique);    return c ? c.color : '#353535'; },
      selectedApplique2Hex()     { const c = this.applique2Colors.find(c => c.id === this.colorModal.selectedApplique2);  return c ? c.color : '#353535'; },
      selectedFabricName()       { const c = this.fabricColors.find(c => c.id === this.colorModal.selectedFabric);       return c ? c.name  : ''; },
      selectedEmbroideryName()   { const c = this.embroideryColors.find(c => c.id === this.colorModal.selectedEmbroidery);  return c ? c.name  : ''; },
      selectedEmbroidery2Name()  { const c = this.embroidery2Colors.find(c => c.id === this.colorModal.selectedEmbroidery2); return c ? c.name  : ''; },
      selectedAppliqueName()     { const c = this.appliqueColors.find(c => c.id === this.colorModal.selectedApplique);    return c ? c.name  : ''; },
      selectedApplique2Name()    { const c = this.applique2Colors.find(c => c.id === this.colorModal.selectedApplique2);  return c ? c.name  : ''; },
      /* Monogram color recommendations based on selected layer colors.
         Letter → embroidery; Detail → appliqué (priority) or embroidery.
         Falls back to fabricColors/embroideryColors/appliqueColors arrays when no custom selection. */
      _recommendedMonogramColors() {
        const idx = this.monogramModal.productIdx;
        if (idx === null) return { letter: null, detail: null };
        const p = this.products[idx];
        if (!p) return { letter: null, detail: null };
        const info = p.customColorInfo;
        let embHex = null, appHex = null, fabHex = null;
        const resolve = id => this.monogramColors.find(c => c.id === id) || null;
        if (info) {
          embHex = info.embroideryColor || null;
          appHex = info.appliqueColor   || null;
          fabHex = info.fabricColor     || null;
          const letterHex = embHex || appHex || fabHex;
          const detailHex = appHex || embHex || fabHex;
          return {
            letter: letterHex ? resolve(this._closestMonogramColor(letterHex)) : null,
            detail: detailHex ? resolve(this._closestMonogramColor(detailHex)) : null,
          };
        } else {
          /* Recommended color selected — use the monogram_suggestion_hex1/hex2 baked into the combo */
          const selectedOpt = (p.colorOptions || []).find(c => c.id === p.color);
          if (selectedOpt && (selectedOpt.monoHex1 || selectedOpt.monoHex2)) {
            return {
              letter: selectedOpt.monoHex1 ? resolve(this._closestMonogramColor(selectedOpt.monoHex1)) : null,
              detail: selectedOpt.monoHex2 ? resolve(this._closestMonogramColor(selectedOpt.monoHex2)) : null,
            };
          }
          return { letter: null, detail: null };
        }
      },
      recommendedMonogramLetter() { return this._recommendedMonogramColors.letter; },
      recommendedMonogramDetail()  { return this._recommendedMonogramColors.detail; },
      currentProduct()          { return this.monogramModal.productIdx !== null ? this.products[this.monogramModal.productIdx] : null; },
      currentProductPositions() {
        const p = this.currentProduct;
        if (!p) return [];
        return this.monogramPositionImages.filter(pos => pos.product_type_id === p.typeNum);
      },
      monogramLibraryStyles() {
        let styles;
        if (this.monogramModal.activeTab === 'contemporary') styles = this.contemporaryStyles;
        else if (this.monogramModal.activeTab === 'children') styles = this.childrenStyles;
        else styles = this.classicStyles;
        const count = this.monogramModal.activeLetterCount;
        return (styles || []).filter(s => (s.max || 3) === count);
      },
      selectedMonogramStyle() {
        const id = this.monogramModal.selection.styleId;
        if (!id) return null;
        const allStyles = [
          ...(this.classicStyles || []),
          ...(this.contemporaryStyles || []),
          ...(this.childrenStyles || []),
          ...(this.recommendedStyles || []),
        ];
        return allStyles.find(s => s.id === id) || null;
      },
      currentMonogramMax() {
        return (this.selectedMonogramStyle && this.selectedMonogramStyle.max) || 3;
      },
      currentMonogramColorQty() {
        return (this.selectedMonogramStyle && this.selectedMonogramStyle.colorQty) || 2;
      },
      monogramPriceFormatted()  { return formatPrice(this.monogramPriceCents, shopify.currency || 'EUR'); },
      monogramStep1Valid()      { return !!this.monogramModal.selection.styleId; },
      monogramStep2Valid()      { const l = this.monogramModal.selection.letters; return !!(l && l.length > 0); },
      monogramStep3Valid()      { return this.monogramModal.colorsConfirmed && !!this.monogramModal.selection.sleepingLetterColor; },
      monogramStep4Valid()      { return !!this.monogramModal.selection.location; },
      monogramLetterColorName() { const c = this.monogramColors.find(c => c.id === this.monogramModal.selection.sleepingLetterColor); return c ? c.name : ''; },
      monogramDetailColorName() { const c = this.monogramColors.find(c => c.id === this.monogramModal.selection.sleepingDetailColor);  return c ? c.name : ''; },
      colorModalSvg() {
        if (this.colorModal.productIdx === null) return null;
        const p = this.products[this.colorModal.productIdx];
        if (!p) return null;
        return p.typeNum <= 3 ? this.svgMain : this.svgDecorative;
      },
    },

    watch: {
      'colorModal.selectedFabric':      function() { this.$nextTick(() => this._applySvgColors()); },
      'colorModal.selectedEmbroidery':  function() { this.$nextTick(() => this._applySvgColors()); },
      'colorModal.selectedEmbroidery2': function() { this.$nextTick(() => this._applySvgColors()); },
      'colorModal.selectedApplique':    function() { this.$nextTick(() => this._applySvgColors()); },
      'colorModal.selectedApplique2':   function() { this.$nextTick(() => this._applySvgColors()); },
      colorModalSvg:                    function() { this.$nextTick(() => this._applySvgColors()); },
      currentMonogramMax(max) {
        const letters = this.monogramModal.selection.letters;
        if (letters && letters.length > max) {
          this.monogramModal.selection.letters = letters.slice(0, max);
        }
      },
    },

    methods: {
      prevHero()   { this.heroSlide   = (this.heroSlide   - 1 + this.heroImages.length)   % this.heroImages.length; },
      nextHero()   { this.heroSlide   = (this.heroSlide   + 1) % this.heroImages.length; },
      prevBundle() { this.bundleSlide = (this.bundleSlide - 1 + this.bundleImages.length) % this.bundleImages.length; },
      nextBundle() { this.bundleSlide = (this.bundleSlide + 1) % this.bundleImages.length; },
      prevAbout()  { const n = shopify.aboutImageCount || 2; this.aboutSlide = (this.aboutSlide - 1 + n) % n; },
      nextAbout()  { const n = shopify.aboutImageCount || 2; this.aboutSlide = (this.aboutSlide + 1) % n; },

      updateQty(idx, delta) {
        const p = this.products[idx];
        p.quantity = Math.max(1, p.quantity + delta);
        if (p.unitPriceCents != null) {
          p.price = formatPrice(p.unitPriceCents * p.quantity, shopify.currency || 'EUR');
        }
      },

      getColorLabel(product) {
        const opts = (product && product.colorOptions) || FALLBACK_COLOR_OPTIONS;
        const c = opts.find(c => c.id === product.color);
        if (!c) return '';
        const parts = c.ariaLabel.split(' / ');
        if (parts.length <= 1) return c.ariaLabel;
        /* Build layer list matching display order: Fabric → Appliqué → Appliqué2 → Embroidery → Embroidery2
           Only include layers that are actually enabled, so positions match the ariaLabel parts. */
        const layerNames = ['Fabric'];
        if (this.applique_exists)    layerNames.push(this.appliqueLabel);
        if (this.applique2_exists)   layerNames.push(this.applique2Label);
        if (this.embroidery_exists)  layerNames.push(this.embroideryLabel);
        if (this.embroidery2_exists) layerNames.push(this.embroidery2Label);
        /* When there are more active layers than colors given in the swatch's ariaLabel
           (e.g. a 2-color combo used on a bundle with 3+ active layers), reuse the last
           given color for the remaining layers instead of silently dropping them —
           iterate over layerNames, not parts, and fall back to parts[parts.length - 1]. */
        return layerNames
          .map((name, i) => (parts[i] !== undefined ? parts[i] : parts[parts.length - 1]) + ' ' + name)
          .join(' / ');
      },

      selectRecommendedColor(colorId, idx) {
        if (this.isFirstSelection) {
          this.products.forEach(p => { p.customColorInfo = null; p.color = colorId; p.colorChosen = true; });
          this.isFirstSelection = false;
        } else {
          this.products[idx].customColorInfo = null;
          this.products[idx].color = colorId;
          this.products[idx].colorChosen = true;
        }
      },

      clearCustomColor(idx) {
        this.products[idx].customColorInfo = null;
        this.products[idx].color = (this.products[idx].colorOptions[0] || {}).id || 'white-black';
      },

      togglePureBlissExpand(idx) { this.products[idx].pureBlissExpanded = !this.products[idx].pureBlissExpanded; },

      togglePureBliss(idx) {
        const p = this.products[idx];
        if (p.fabricType.includes('Pure Bliss')) {
          p.fabricType = p.fabricType === 'Pure Bliss Linen' ? 'Fine Linen' : 'Cotton Percale';
        } else {
          p.fabricType = p.fabricType === 'Fine Linen' ? 'Pure Bliss Linen' : 'Pure Bliss Cotton';
        }
        this.syncPrice(idx);
      },

      toggleMonogramCheck(idx) {
        const p = this.products[idx];
        if (!p.monogram) { p.monogram = true; this.openMonogramModal(idx); }
        else             { p.monogram = false; p.monogramSelection = null; }
      },
      removeMonogram(idx) { this.products[idx].monogramSelection = null; this.products[idx].monogram = false; },

      /* Color Modal */
      openColorModal(idx) {
        const firstFabric = (this.fabricColors[0]      || {}).id || 'f0';
        const firstEmb    = (this.embroideryColors[0]  || {}).id || 'e0';
        const firstEmb2   = (this.embroidery2Colors[0] || {}).id || 'e20';
        const firstApp    = (this.appliqueColors[0]    || {}).id || 'a0';
        const firstApp2   = (this.applique2Colors[0]   || {}).id || 'a20';
        Object.assign(this.colorModal, {
          isOpen: true, productIdx: idx,
          selectedFabric:      firstFabric,
          selectedEmbroidery:  firstEmb,
          selectedEmbroidery2: firstEmb2,
          selectedApplique:    firstApp,
          selectedApplique2:   firstApp2,
          showAllFabric:       false,
          showAllEmbroidery:   false,
          showAllEmbroidery2:  false,
          showAllApplique:     false,
          showAllApplique2:    false,
        });
      },
      closeColorModal() { this.colorModal.isOpen = false; this.colorModal.productIdx = null; },
      applyColorSelection() {
        const idx = this.colorModal.productIdx;
        if (idx === null) return;
        const fabric  = this.fabricColors.find(c => c.id === this.colorModal.selectedFabric);
        const emb     = this.embroideryColors.find(c => c.id === this.colorModal.selectedEmbroidery);
        const emb2    = this.embroidery2Colors.find(c => c.id === this.colorModal.selectedEmbroidery2);
        const app     = this.appliqueColors.find(c => c.id === this.colorModal.selectedApplique);
        const app2    = this.applique2Colors.find(c => c.id === this.colorModal.selectedApplique2);
        if (fabric) {
          /* Only include a layer's color if that layer is actually enabled on this bundle.
             embroideryColors/appliqueColors fall back to FALLBACK data even when the layer
             doesn't exist, so we must gate on the _exists flags to avoid ghost selections. */
          const info = {
            fabricColor:      fabric.color,
            fabricName:       fabric.name,
            embroideryColor:  this.embroidery_exists  && emb  ? emb.color  : null,
            embroideryName:   this.embroidery_exists  && emb  ? emb.name   : null,
            embroidery2Color: this.embroidery2_exists && emb2 ? emb2.color : null,
            embroidery2Name:  this.embroidery2_exists && emb2 ? emb2.name  : null,
            appliqueColor:    this.applique_exists    && app  ? app.color  : null,
            appliqueName:     this.applique_exists    && app  ? app.name   : null,
            applique2Color:   this.applique2_exists   && app2 ? app2.color : null,
            applique2Name:    this.applique2_exists   && app2 ? app2.name  : null,
          };
          if (this.isFirstSelection) {
            this.products.forEach(p => { p.color = 'custom'; p.customColorInfo = { ...info }; p.colorChosen = true; });
            this.isFirstSelection = false;
          } else {
            this.products[idx].color = 'custom';
            this.products[idx].customColorInfo = info;
            this.products[idx].colorChosen = true;
          }
        }
        this.closeColorModal();
      },

      /* Monogram Modal */
      _closestMonogramColor(hex) {
        if (!hex || !this.monogramColors.length) return 'ecru';
        const parse = h => {
          const s = h.replace('#', '');
          return [parseInt(s.slice(0,2),16)||0, parseInt(s.slice(2,4),16)||0, parseInt(s.slice(4,6),16)||0];
        };
        const [r1,g1,b1] = parse(hex);
        let best = this.monogramColors[0];
        let bestDist = Infinity;
        this.monogramColors.forEach(mc => {
          const [r2,g2,b2] = parse(mc.color || '#000');
          const dist = Math.sqrt((r1-r2)**2+(g1-g2)**2+(b1-b2)**2);
          if (dist < bestDist) { bestDist = dist; best = mc; }
        });
        return best.id;
      },

      openMonogramModal(idx) {
        const p = this.products[idx];

        let letterColor = 'ecru';
        let detailColor = 'ecru';
        if (!p.monogramSelection) {
          const info = p.customColorInfo;
          if (info) {
            const embHex = info.embroideryColor || null;
            const appHex = info.appliqueColor   || null;
            const fabHex = info.fabricColor     || null;
            const lHex = embHex || appHex || fabHex;
            const dHex = appHex || embHex || fabHex;
            if (lHex) letterColor = this._closestMonogramColor(lHex);
            if (dHex) detailColor = this._closestMonogramColor(dHex);
          } else {
            /* Use monogram_suggestion_hex1/hex2 from the selected recommended combo */
            const selectedOpt = (p.colorOptions || []).find(c => c.id === p.color);
            if (selectedOpt && selectedOpt.monoHex1) letterColor = this._closestMonogramColor(selectedOpt.monoHex1);
            if (selectedOpt && selectedOpt.monoHex2) detailColor = this._closestMonogramColor(selectedOpt.monoHex2);
          }
        }

        Object.assign(this.monogramModal, {
          isOpen: true, productIdx: idx, currentStep: 1,
          showAllStyles: false, activeTab: 'classic', activeLetterCount: 1, showCustomColors: false,
          hoveredStyleId: null, showAllLetterColors: false, showAllDetailColors: false,
          colorsConfirmed: !!p.monogramSelection,
        });
        this.monogramModal.selection = p.monogramSelection
          ? { ...p.monogramSelection }
          : { styleId: null, styleName: '', styleImage: '', stylePlaceholder: '', letters: '', sleepingLetterColor: letterColor, sleepingDetailColor: detailColor, location: '' };
      },
      closeMonogramModal() {
        const idx = this.monogramModal.productIdx;
        if (idx !== null && !this.products[idx].monogramSelection) this.products[idx].monogram = false;
        this.monogramModal.isOpen = false;
        this.monogramModal.productIdx = null;
      },
      selectMonogramStyle(style) {
        Object.assign(this.monogramModal.selection, { styleId: style.id, styleName: style.name, styleImage: style.image || '', styleHoverImage: style.hoverImage || style.image || '', stylePlaceholder: style.placeholder || '' });
      },
      monoNext() {
        if (this.monogramModal.currentStep === 1 && !this.monogramStep1Valid) return;
        if (this.monogramModal.currentStep === 2 && !this.monogramStep2Valid) return;
        /* Step 3: auto-confirm with recommended colors if still on recommended view */
        if (this.monogramModal.currentStep === 3) {
          if (!this.monogramModal.showCustomColors) {
            /* Apply recommended colors and confirm */
            if (this.recommendedMonogramLetter) this.monogramModal.selection.sleepingLetterColor = this.recommendedMonogramLetter.id;
            if (this.recommendedMonogramDetail)  this.monogramModal.selection.sleepingDetailColor = this.recommendedMonogramDetail.id;
            this.monogramModal.colorsConfirmed = true;
          } else {
            this.monogramModal.colorsConfirmed = true;
          }
          if (!this.monogramStep3Valid) return;
        }
        if (this.monogramModal.currentStep < 4) this.monogramModal.currentStep++;
      },
      monoPrev() { if (this.monogramModal.currentStep > 1) this.monogramModal.currentStep--; },
      completeMonogram() {
        const idx = this.monogramModal.productIdx;
        if (idx === null || !this.monogramStep4Valid) return;
        this.products[idx].monogramSelection = { ...this.monogramModal.selection };
        this.products[idx].monogram = true;
        this.monogramModal.isOpen = false;
        this.monogramModal.productIdx = null;
      },
      updateMonogramLetters(e) { this.monogramModal.selection.letters = e.target.value.toUpperCase().slice(0, this.currentMonogramMax); },
      selectMonogramLocation(loc) { this.monogramModal.selection.location = loc; },

      /* ── Build cart line items for a product (shared by confirm + submit) ── */
      _buildLineItems(p) {
        const randNum = Math.floor(Math.random() * 100000);
        const items   = [];

        const info = p.customColorInfo;
        let fabricColor, embColor, emb2Color, appColor, app2Color;
        if (info) {
          fabricColor = info.fabricName + ' Fabric';
          embColor    = info.embroideryColor  ? info.embroideryName  + ' ' + (shopify.embroideryLabel  || 'Embroidery')         : '';
          emb2Color   = info.embroidery2Color ? info.embroidery2Name + ' ' + (shopify.embroidery2Label || 'Secondary Embroidery') : '';
          appColor    = info.appliqueColor    ? info.appliqueName    + ' ' + (shopify.appliqueLabel    || 'Appliqué')            : '';
          app2Color   = info.applique2Color   ? info.applique2Name   + ' ' + (shopify.applique2Label   || 'Second Appliqué')     : '';
        } else {
          /* Recommended colors: parse label parts in the same order getColorLabel builds them:
             Fabric → Appliqué → Appliqué2 → Embroidery → Embroidery2 */
          const label = this.getColorLabel(p);
          const parts = label.split('/').map(s => s.trim());
          let i = 0;
          fabricColor = parts[i++] || '';
          appColor    = this.applique_exists    ? (parts[i++] || '') : '';
          app2Color   = this.applique2_exists   ? (parts[i++] || '') : '';
          embColor    = this.embroidery_exists  ? (parts[i++] || '') : '';
          emb2Color   = this.embroidery2_exists ? (parts[i++] || '') : '';
        }

        const fabricTypeProps = p.typeNum === 6 ? { 'Fabric Type': 'Italian Piquet' } : { 'Fabric Type': '' };
        const colorProps = { 'Appliqué Color': appColor, 'Second Appliqué Color': app2Color, 'Embroidery Color': embColor, 'Second Embroidery Color': emb2Color };

        const bid = 'b_' + randNum + '_' + (p.variantId || '');

        if (p.monogram && p.monogramSelection && p.monogramSelection.letters) {
          const sel = p.monogramSelection;
          const letterColorObj = this.monogramColors.find(c => c.id === sel.sleepingLetterColor);
          const detailColorObj = this.monogramColors.find(c => c.id === sel.sleepingDetailColor);
          const allStyles = [
            ...(this.classicStyles || []),
            ...(this.contemporaryStyles || []),
            ...(this.childrenStyles || []),
            ...(this.recommendedStyles || []),
          ];
          const selStyle = allStyles.find(s => s.id === sel.styleId);
          const styleColorQty = (selStyle && selStyle.colorQty) || 2;
          const monoProps = {
            ...fabricTypeProps, 'Fabric Color': fabricColor, ...colorProps,
            'Monogram Alphabet': sel.styleName || '', 'Monogram Letters': sel.letters,
            'Monogram Letter Color': letterColorObj ? letterColorObj.name : '',
            'Monogram Position': sel.location || '',
            '_type': 'Master', '_bid': bid,
          };
          if (styleColorQty >= 2) {
            monoProps['Monogram Detail Color'] = detailColorObj ? detailColorObj.name : '';
          }
          items.push({ id: p.variantId, quantity: p.quantity, properties: monoProps });
          const monoVariantId = p.monogramVariantId || this.monogramVariants[p.typeNum] || null;
          if (monoVariantId) {
            items.push({ id: monoVariantId, quantity: p.quantity, properties: { '_type': 'Child', '_bid': bid } });
          }
        } else {
          items.push({
            id: p.variantId, quantity: p.quantity,
            properties: { ...fabricTypeProps, 'Fabric Color': fabricColor, ...colorProps },
          });
        }
        /* Extra per-product fields — only add when non-empty */
        const extraProps = {};
        if (p.initials)      extraProps['Initials']       = p.initials;
        if (p.initial)       extraProps['Initial']        = p.initial;
        if (p.customRequest) extraProps['Custom Request'] = p.customRequest;
        if (p.bdayName)      extraProps['Birthday Name']  = p.bdayName;
        if (p.bdayDay)       extraProps['Birthday Day']   = p.bdayDay;
        if (p.bdayMonth)     extraProps['Birthday Month'] = p.bdayMonth;
        if (p.bdayYear)      extraProps['Birthday Year']  = p.bdayYear;

        if (Object.keys(extraProps).length) {
          items.forEach(item => Object.assign(item.properties, extraProps));
        }

        return items;
      },

      /* ── Confirm Selection — local only, no network call ─────── */
      addToCart(idx) {
        const p = this.products[idx];
        if (!p || !p.variantId || !p.colorChosen) return;
        if (p.variantAvailable === false) { alert('Sorry, this size is currently out of stock.'); return; }

        const cur       = shopify.currency || 'EUR';
        const monoQty   = (p.monogram && p.monogramSelection) ? p.quantity : 0;
        const lineCents = (p.unitPriceCents || 0) * p.quantity + this.monogramPriceCents * monoQty;

        const newItem = {
          _variantId:   p.variantId,
          _lineCents:   lineCents,
          _lineItems:   this._buildLineItems(p),
          title:        p.title,
          variantTitle: [p.fabricType, p.size].filter(Boolean).join(' · '),
          quantity:     p.quantity,
          price:        formatPrice(lineCents, cur),
          image:        p.image || '',
          monogram:     p.monogramSelection ? p.monogramSelection.letters : null,
          styleName:    p.monogramSelection ? p.monogramSelection.styleName : null,
        };

        const updatedItems = [...this.cartDrawer.items];
        const existing = updatedItems.findIndex(i => i._variantId === p.variantId);
        if (existing >= 0) {
          this._cartTotalCents = ((this._cartTotalCents || 0) - updatedItems[existing]._lineCents) + lineCents;
          updatedItems[existing] = newItem;
        } else {
          this._cartTotalCents = (this._cartTotalCents || 0) + lineCents;
          updatedItems.push(newItem);
        }

        this.cartDrawer = {
          isOpen:    true,
          loading:   false,
          items:     updatedItems,
          itemCount: updatedItems.reduce((n, i) => n + i.quantity, 0),
          total:     formatPrice(this._cartTotalCents, cur),
        };
      },

      /* ── Submit all confirmed items to Shopify, then go to cart ─ */
      submitCart() {
        if (!this.cartDrawer.items.length) return;

        /* Pre-flight: verify all confirmed variants are still available */
        const unavailable = this.cartDrawer.items.filter(i => {
          const p = this.products.find(prod => prod.variantId === i._variantId);
          return p && p.variantAvailable === false;
        });
        if (unavailable.length) {
          alert('Some items in your bag are out of stock: ' + unavailable.map(i => i.title).join(', ') + '. Please update your selection.');
          return;
        }

        this.cartDrawer.loading = true;
        const allItems = this.cartDrawer.items.flatMap(i => i._lineItems);

        const xhr = new XMLHttpRequest();
        xhr.open('POST', '/cart/add.js');
        xhr.setRequestHeader('Content-Type', 'application/json');
        xhr.onload = () => {
          if (xhr.status >= 200 && xhr.status < 300) {
            window.location.href = '/cart';
          } else {
            this.cartDrawer.loading = false;
            alert('Could not submit your bag. Please try again.');
          }
        };
        xhr.onerror = () => {
          this.cartDrawer.loading = false;
          alert('Could not submit your bag. Please try again.');
        };
        xhr.send(JSON.stringify({ items: allItems }));
      },

      /* ── Variant price sync ──────────────────────────────────── */
      fabricToBackend(displayName) {
        const map = {
          'Cotton Percale':    ['Percale', 'Cotton Percale'],
          'Fine Linen':        ['Linen', 'Fine Linen'],
          'Pure Bliss Cotton': ['Pure Bliss Cotton', 'Pure Bliss'],
          'Pure Bliss Linen':  ['Pure Bliss Linen', 'Pure Bliss'],
        };
        return map[displayName] || [displayName];
      },

      _applySvgColors() {
        const el = document.querySelector('.jb-svg-preview svg');
        if (!el) return;
        const set = (id, color) => {
          const node = el.querySelector('#' + id);
          if (node) node.style.fill = color;
        };
        set('Fabric',     this.selectedFabricHex);
        set('Lines',      this.selectedFabricHex);
        set('Embroidery',  this.selectedEmbroideryHex);
        set('Embroidery2', this.selectedEmbroidery2Hex);
        set('Applique',    this.selectedAppliqueHex);
        set('Applique2',   this.selectedApplique2Hex);
      },

      startSvgLoop(container) {
        this.stopSvgLoop();
        const svg = container && container.querySelector('svg');
        if (!svg) return;

        // Prefer known layer IDs in display order; fall back to any visible [id] element
        const knownIds = ['Fabric', 'Lines', 'Embroidery', 'Embroidery2', 'Applique', 'Applique2'];
        let layers = knownIds.map(id => svg.querySelector('#' + id)).filter(Boolean);
        if (!layers.length) {
          layers = Array.from(svg.querySelectorAll('[id]')).filter(el => {
            const tag = el.tagName.toLowerCase();
            return tag !== 'defs' && tag !== 'clippath' && tag !== 'mask' && tag !== 'filter';
          });
        }
        if (layers.length < 2) return; // nothing interesting to loop through

        let idx = 0;
        const tick = () => {
          layers.forEach((el, i) => { el.style.opacity = i === idx ? '1' : '0.15'; });
          idx = (idx + 1) % layers.length;
          this._svgLoopTimer = setTimeout(tick, 650);
        };
        tick();
      },

      stopSvgLoop() {
        clearTimeout(this._svgLoopTimer);
        this._svgLoopTimer = null;
        document.querySelectorAll('.jb-svg-preview svg [id]').forEach(el => { el.style.opacity = ''; });
      },

      syncPrice(idx) {
        const p = this.products[idx];
        if (!Array.isArray(p.variantData) || !p.variantData.length) return;
        const fabricCandidates = this.fabricToBackend(p.fabricType);
        const matches = p.variantData.filter(v => {
          const fVal = p.fabricOptIdx >= 0 ? getVariantOptionVal(v, p.fabricOptIdx) : null;
          const sVal = p.sizeOptIdx   >= 0 ? getVariantOptionVal(v, p.sizeOptIdx)   : null;
          const fabricOk = !fVal || fabricCandidates.some(fc => fc.toLowerCase() === fVal.toLowerCase());
          const sizeOk   = !sVal || sVal === p.size;
          return fabricOk && sizeOk;
        });
        /* Prefer an available variant; fall back to unavailable so UI still shows */
        const match = matches.find(v => v.available) || matches[0] || null;
        if (match) {
          p.unitPriceCents = match.price;
          p.price          = formatPrice(match.price * (p.quantity || 1), shopify.currency || 'EUR');
          p.variantId      = match.id;
          p.variantAvailable = match.available;
        }
      },
    },

    mounted() {
      const fetchSvg = (url) => url
        ? fetch(url).then(r => r.ok ? r.text() : null).catch(e => { console.warn('[JB] SVG fetch failed:', url, e); return null; })
        : Promise.resolve(null);

      Promise.all([
        fetchSvg(shopify.svgMainUrl),
        fetchSvg(shopify.svgDecorativeUrl),
      ]).then(([main, decorative]) => {
        if (main)       this.svgMain       = main;
        if (decorative) this.svgDecorative = decorative;
      });

      // Activate sticky on .jb-left only once the user has scrolled down to it
      this.$nextTick(() => {
        const sentinel = document.getElementById('jb-main-sentinel');
        const leftEl   = document.getElementById('jb-left-panel');
        if (!sentinel || !leftEl) return;

        // Snapshot the sentinel's absolute page position (before sticky changes layout)
        var triggerY = sentinel.getBoundingClientRect().top + window.scrollY;

        function updateSticky() {
          leftEl.classList.toggle('is-sticky', window.scrollY >= triggerY);
        }

        window.addEventListener('scroll', updateSticky, { passive: true });
        window.addEventListener('resize', function() {
          leftEl.classList.remove('is-sticky');
          triggerY = sentinel.getBoundingClientRect().top + window.scrollY;
          updateSticky();
        }, { passive: true });

        updateSticky();
      });

    },
  });

  app.mount('#jb-app');
})();

